import { Flex, Typography } from '@percent/lemonade'
import { DonationFormPageHeaderProps } from './DonationFormPage.types'
import { t } from 'i18next'

export const DonationPageHeader = ({ activeTab, setActiveTab }: Readonly<DonationFormPageHeaderProps>) => {
  return (
    <Flex direction="column" data-testid="donation-page-header">
      <Flex p={4} pb={24} gap={8} align="flex-start">
        <Typography variant="h2" data-testid="donation-page-header-title">
          {t('donationForm.page.title')}
        </Typography>
      </Flex>
    </Flex>
  )
}
